// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LayoutOutlinedSvg from "@ant-design/icons-svg/es/asn/LayoutOutlined";
import AntdIcon from '../components/AntdIcon';

var LayoutOutlined = function LayoutOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LayoutOutlinedSvg
  }));
};

LayoutOutlined.displayName = 'LayoutOutlined';
export default React.forwardRef(LayoutOutlined);